import React, { useEffect, useState } from "react";
import moment from "moment";
import OrderCard from "./table-details-card";

// Replace these with actual imports
// import { tablesDetailsAction } from "../redux/actions/table-actions";
import {
    clearTableProductsApi,
    tableEditOrdersApi,
    tableDetailsApi,
} from "../../redux/apis/table-apis";
import errorToast from "../../components/toast/errorToast";
import successToast from "../../components/toast/successToast";
import { Link, useNavigate, useParams } from "react-router-dom";
// import { printKOT } from "../utils/print-helper";

export default function TableDetails() {
    const navigate = useNavigate();
    const [groups, setGroups] = useState({});
    const [data, setData] = useState({});
    const [table, setTable] = useState({});
    const [refreshing, setRefreshing] = useState(true);
    const { id } = useParams();
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setRefreshing(true);
        try {
            var res = await tableDetailsApi({
                restaurant_table_id: id,
            });
            if (res.status == 200) {
                successToast(res.data?.message);
                setGroups(res.data.data.groups || {});
                setData(res.data.data);
                setTable(res.data.data.table);
            } else {
                errorToast(res?.data?.message);
            }
        } catch (error) {
            console.error(error);
            errorToast(error);
        }
        setRefreshing(false);
    };

    const onBack = () => navigate(`/pos/tables`);

    const onCheckout = () => {
        if (data.order) {
           navigate(`/pos/checkout/${data.order.id}`);
        }
    };

    const onClear = async () => {
        try {
            const res = await clearTableProductsApi({
                restaurant_table_id: table?.id,
            });
            if (res.status === 200) {
                fetchData();
            }
        } catch (error) {
            console.error(error);
        }
    };

    if (refreshing) {
        return (
            <div className="h-[90vh] bg-white text-gray-800 flex flex-col">
                <p>loading</p>
            </div>
        );
    }

    return (
        <div className="h-[90vh] bg-white text-gray-800 flex flex-col">
            {/* Header */}
            <header className="h-14 flex items-center justify-between px-4 border-b border-gray-200">
                <div className="flex items-center space-x-3">
                    <button
                        onClick={onBack}
                        className="p-2 hover:bg-gray-100 rounded-lg"
                    >
                        ←
                    </button>
                    <h1 className="text-lg font-bold text-gray-900">
                        {table?.name}
                    </h1>
                </div>
                <button
                    onClick={onCheckout}
                    className="flex items-center bg-red-600 text-white px-3 py-2 rounded-md text-sm font-semibold hover:bg-red-700"
                >
                    🛒 Checkout
                </button>
            </header>

            {/* Clear Button */}
            <div className="flex justify-end p-4">
                <button
                    onClick={onClear}
                    className="flex items-center bg-indigo-50 px-3 py-2 rounded-md text-sm font-semibold text-gray-900 hover:bg-indigo-100"
                >
                    ✕ Clear
                </button>
            </div>

            {/* Orders List */}
            <div className="flex-1 px-4 space-y-4 overflow-y-auto">
                {Object.entries(groups).map(([groupId, products]) => {
                    if (!products || products.length === 0) return null;

                    const groupTime = products[0]?.createdAt
                        ? moment
                              .parseZone(products[0]?.createdAt)
                              .format("hh:mm a")
                        : "";

                    const parcel = products[0]?.parcel;

                    return (
                        <OrderCard
                            key={groupId}
                            order={{
                                group_id: groupId,
                                products,
                                time: groupTime,
                                restaurant_table_id: table?.id,
                                parcel,
                                tableName: table?.name,
                            }}
                        />
                    );
                })}
            </div>

            {/* Footer */}
            <footer className="p-4 border-t border-gray-200">
                <button
                    onClick={() => {
                        navigate(`/pos/add-table-products/${id}`);
                    }}
                    className="w-full bg-indigo-600 text-white py-3 rounded-lg font-medium text-lg hover:bg-indigo-700"
                >
                    Add Items
                </button>
            </footer>
        </div>
    );
}
